export const APP_PATH = {
  // THE single platform-wide timezone endpoint. Every app posts its detected IANA zone here
  // once per session; it is stored on the user record (users.timezone), which is what gives the
  // account's bare wall-clock working hours their meaning. See components/timezone-notice.
  userTimezone: "/api/v1/auth/timezone",
  // Admin-configured reject reasons for this provider (dropdown on the Reject
  // dialogs). Requires ?service_type=pharmacy for pharmacy screens and
  // ?service_type=doctor for the doctor on-site appointment reject.
  providerRejectionReasons: "/api/v1/provider/rejection-reasons",

  login: "/api/v1/consultation/login", //done
  getRole: "/api/v1/consultation/get-roles", //not in use
  getConsultation: "/api/v1/consultation/me", //done
  refreshToken: "/api/v1/consultation/refresh-token", //done
  validateToken: "/api/v1/auth/validate-token", //done - for background refresh
  verificationStatus: "/api/v1/auth/verification-status", //done - for polling verification status
  uploadedDoctorDocuments: "/api/v1/consultation/documents/doctor", //done
  uploadedPharmacyDocuments: "/api/v1/consultation/documents/pharmacy", //done
  getDocument: "/api/v1/consultation/documents/my-documents",
  logout: "/api/v1/consultation/logout", //done
  forgotPassword: "/api/v1/consultation/forgot-password", //done*
  forgotPasswordSendOtp: "/api/v1/consultation/forgot-password/send-otp",
  forgotPasswordVerifyOtp: "/api/v1/consultation/forgot-password/verify-otp",
  forgotPasswordReset: "/api/v1/consultation/forgot-password/reset",
  changePassword: "/api/v1/consultation/change-password",
  resetPassword: "/api/v1/consultation/reset-password", //done*
  uploadDoctorMedia: "/api/v1/media/upload-doctor-document", //done
  uploadAvatar: "/api/v1/media/upload-avatar", //done
  uploadPharmacyMedia: "/api/v1/media/upload-pharmacy-document", //done
  // getUploadDoc:"/api/v1/consultation/documents/my-documents",
  patientRegistration: "/api/v1/consultation/patient/register", //done
  // Doctor → patient app-download link (WhatsApp, OTPIQ SMS fallback). Creates nothing.
  sendPatientAppLink: "/api/v1/consultation/doctor/patients/send-app-link",
  // patient_register: "/api/v1/consultation/patient/register",
  // doctorProfile: "/api/v1/doctors/profile",
  doctorProfile: "/api/v1/consultation/doctor/profile", //done

  doctorVisibility: "/api/v1/doctors/profile/patient-visibility",

  getDoctorAppointments: "/api/v1/consultation/doctor/appointments",
  getAppointmentById: "/api/v1/consultation/doctor/appointments",
  // Doctor's own available time slots for a date (operating-hours driven). The doctor
  // profile id is resolved server-side from the JWT user id.
  getDoctorAvailableSlots:
    "/api/v1/consultation/doctor/appointments/available-slots",
  updateDoctorPersonalInfo: "/api/v1/consultation/doctor/personal-information", //Update doctor personal information  working
  updateDoctorPatientCount: "/api/v1/consultation/doctor/patient-count", //Update doctor patient count visibility working
  updateDoctorClinicSchedule: "/api/v1/consultation/doctor/clinic-schedule", //add data done
  updateDoctorEmergencySchedule:
    "/api/v1/consultation/doctor/midnight-schedule", //emergency/midnight schedule
  updateOnsiteSchedule: "/api/v1/consultation/doctor/appointments",
  // Doctor accept/reject of an ONLINE (video) consultation request. Same controller as the
  // onsite schedule update; the route suffix differs (`/update-online-decision`).
  updateOnlineDecision: "/api/v1/consultation/doctor/appointments",
  doctorAppointmentsPatients:
    "/api/v1/consultation/doctor/appointments/patients",
  requestAppointmentReschedule: "/api/v1/consultation/doctor/appointments",
  createFollowupAppointment: "/api/v1/consultation/doctor/appointments",
  completeAppointmentWithAction: "/api/v1/consultation/doctor/appointments",

  // Pharmacy
  pharmacyForgotPasswordSendOtp: "/api/v1/pharmacy/forgot-password/send-otp",
  pharmacyForgotPasswordVerifyOtp:
    "/api/v1/pharmacy/forgot-password/verify-otp",
  pharmacyForgotPasswordReset: "/api/v1/pharmacy/forgot-password/reset",
  verifyOtp: "/api/v1/auth/patient/verify-otp", //done
  resendOtp: "/api/v1/auth/patient/resend-otp", //done
  joinDoctorAppointment: "/api/v1/consultation/doctor/appointments",
  getDoctorConsultationPricing: "/admin/doctors/consultation-pricing",
  getDoctorConsultationFees: "/api/v1/consultation/doctor/consultation-fees",
  createUpdateConsultationFee: "/api/v1/consultation/doctor/consultation-fees",
  // Admin-configured min/max per fee type (null bound = no limit).
  getConsultationFeeLimits:
    "/api/v1/consultation/doctor/consultation-fee-limits",
  // The doctor's own active promo code (admin-assigned, read-only). `data: null` is a normal
  // success: no code assigned, code inactive/expired, or promo codes switched off platform-wide.
  getDoctorPromoCode: "/api/v1/consultation/doctor/promo-code",
  getDoctorWallet: "/api/v1/consultation/doctor/wallet",
  getDoctorWalletTransactions:
    "/api/v1/consultation/doctor/wallet/transactions",
  getDoctorWalletUnifiedTransactions:
    "/api/v1/consultation/doctor/wallet/transactions",
  doctorWalletWithdraw: "/api/v1/consultation/doctor/wallet/withdraw",
  getDoctorWalletWithdrawals: "/consultation/doctor/wallet/withdrawals",

  // Settlement / Payout Account (payment-service)
  submitSettlementRequest: "/api/v1/payment/settlements/request",
  getProviderSettlements: "/api/v1/payment/settlements",
  getSettlementDashboard: "/api/v1/payment/settlements/dashboard",
  payoutAccounts: "/api/v1/payment/payout-accounts",
  getDefaultPayoutAccount: "/api/v1/payment/payout-accounts/default",
  homeVisitSchedule: "/api/v1/consultation/doctor/home-visit-schedule",
  emergencyHomeVisitSchedule:
    "/api/v1/consultation/doctor/midnight-home-visit-schedule",
  homeVisitOnline: "/api/v1/consultation/doctor/home-visit/online",
  emergencyOnline: "/api/v1/consultation/doctor/midnight/online",
  emergencyHomeVisitOnline:
    "/api/v1/consultation/doctor/midnight-home-visit/online",
  getDoctorHomeVisitRequests: "/api/v1/consultation/doctor/home-visit/orders",
  getDoctorUpcomingAppointments:
    "/api/v1/consultation/doctor/home-visit/upcoming-appointments",
  uploadDoctorAvatar: "/api/v1/media/doctor/upload-avatar",
  uploadPrescription: "/api/v1/media/upload-prescription",
  uploadDoctorStampSignature: "/api/v1/media/doctor/upload-stamp-signature",
  savePrescription: "/api/v1/consultation/prescription/save",
  getPatientAddressesForDoctor: "/api/v1/consultation/doctor/patient-addresses",
  getServiceCentersForDoctor: "/api/v1/consultation/doctor/service-centers",
  getPrescriptionByAppointment:
    "/api/v1/consultation/prescription/by-appointment",
  getPatientDetails: "/api/v1/consultation/patient/details",
  // Lightweight chat participant lookup (name + presigned avatar by user id) —
  // used by the global ChatDock header on any screen (incl. general chats).
  chatParticipant: "/api/v1/consultation/chat/participant",
  getPharmacyCategories: "/api/v1/consultation/doctor/pharmacy/categories",
  searchPharmacyMedicinesForDoctor:
    "/api/v1/consultation/doctor/pharmacy/medicines/search",
  searchLabTests: "/api/v1/lab-tests",
  searchImagingTests: "/api/v1/imaging-tests",
  searchPhysioServices: "/api/v1/physio-services",
  searchNurseServices: "/api/v1/nurse-services",
  getSpecialties: "/api/v1/consultation/specialties",
  getDoctorsForReferral: "/api/v1/consultation/doctors-for-referral",
  createDoctorReferral: "/api/v1/consultation/doctor/appointments",
  getDoctorReferralsSent: "/api/v1/consultation/doctor/doctor-referrals",
  // Operation referral (MCC 2). Catalogue: `${operationCatalogHospitals}` lists hospitals;
  // `${operationCatalogHospitals}/${hospitalId}/categories` and
  // `${operationCatalogHospitals}/${hospitalId}/operations?category_id=` narrow it down.
  operationCatalogHospitals:
    "/api/v1/consultation/doctor/operation-catalog/hospitals",
  getDoctorOperationReferrals: "/api/v1/consultation/doctor/operation-referrals",
  // Suffixed per appointment: `${createOperationReferral}/${appointmentId}/operation-referral`.
  createOperationReferral: "/api/v1/consultation/doctor/appointments",
  createRevisitRequest: "/api/v1/consultation/doctor/appointments",
  // In-clinic visit scheduled after a completed ONLINE consultation. The first two are
  // suffixed per appointment: `${clinicVisit}/${appointmentId}/clinic-visit`.
  clinicVisit: "/api/v1/consultation/doctor/appointments",
  clinicVisitEligibility:
    "/api/v1/consultation/doctor/clinic-visit-eligibility",
  updateAcceptInsuranceOrders:
    "/api/v1/consultation/doctor/accept-insurance-orders",

  // Doctor Additional Income
  additionalIncomeSummary:
    "/api/v1/consultation/doctor/additional-income/summary",
  additionalIncomeActivities:
    "/api/v1/consultation/doctor/additional-income/activities",

  insuranceLogin: "/api/v1/insurance/login",
  insurancelogout: "/api/v1/insurance/logout",
  medicalOrders: "/api/v1/insurance/claims/medical-orders",
  doctorConsultation: "/api/v1/insurance/claims/doctor-consultation",
  labTests: "/api/v1/insurance/claims/lab-tests",
  statistics: "/api/v1/insurance/claims/statistics",
  history: "/api/v1/insurance/claims/history",
  claims: "/api/v1/insurance/claims/{claimId}", // /api/v1/insurance/claims/{claimId}
  verify: "/api/v1/insurance/claims/{claimId}/verify",

  claimsReject: "/api/v1/insurance/claims/{claimId}/reject",
  claimsApproveItem: "/api/v1/insurance/claims/{claimId}/approve-item",
  claimsRejectItem: "/api/v1/insurance/claims/{claimId}/reject-item",
  claimsCalculate: "/api/v1/insurance/claims/{claimId}/calculate",
  claimsinvoice: "/api/v1/insurance/claims/{claimId}/invoice",
  claimsexport: "/api/v1/insurance/claims/export",
  claimsdocuments: "/api/v1/insurance/claims/{claimId}/documents",

  //   /api/v1/insurance/claims/{claimId}/documents/request

  getPharmacyOrders: "/api/v1/pharmacy/orders",
  getPharmacyRecentOrders: "/api/v1/pharmacy/orders/recent",
  getPharmacyOrdersHistory: "/api/v1/pharmacy/orders/history",
  getPharmacyCartOrderRequests: "/api/v1/pharmacy/orders/cart-requests",
  getPharmacyDashboardMetrics: "/api/v1/pharmacy/dashboard/metrics",
  getPharmacySalesSummary: "/api/v1/pharmacy/dashboard/sales-summary",
  getPharmacyPopularProducts: "/api/v1/pharmacy/dashboard/popular-products",
  getPharmacyTransactionHistory: "/api/v1/pharmacy/transaction-history",
  approvePharmacyOrder: "/api/v1/pharmacy/orders",
  confirmPharmacyOrder: "/api/v1/pharmacy/orders",
  rejectPharmacyOrder: "/api/v1/pharmacy/orders",
  updateFulfillmentStatus: "/api/v1/pharmacy/orders",
  updateOrderItemPrice: "/api/v1/pharmacy/orders",
  searchPharmacyMedicines: "/api/v1/pharmacy/medicines/search",
  searchPharmacyMedicinesAndCosmetics: "/api/v1/pharmacy/medicines/search-all",
  getPharmacyProducts: "/api/v1/pharmacy/products",
  getPharmacyCosmetics: "/api/v1/pharmacy/cosmetics",
  getPharmacyWallet: "/api/v1/pharmacy/wallet/balance",

  // Doctor Address Management
  manageDoctorAddress: "/api/v1/consultation/doctor/address",
  setDefaultDoctorAddress: "/api/v1/consultation/doctor/address/default",
  getDoctorAddresses: "/api/v1/consultation/doctor/addresses",


  // Doctor Registration
  registerDoctorComplete: "/api/v1/consultation/doctor/register-complete",
  getDoctorRegistrationDetails:
    "/api/v1/consultation/doctor/registration-details",

  // Regions catalog (governorate-level) — used to restrict/autofill the address.
  regions: "/api/v1/auth/regions",

  // Doctor-facing prescription history for a patient (all doctors' prescriptions,
  // with the case notes of the appointment each was written in). Append
  // `/{patientId}/prescription-history`.
  doctorPatientPrescriptionHistory:
    "/api/v1/consultation/doctor/appointments/patients",

  // Doctor-facing uploaded reports for a patient (lab / imaging / physiotherapy
  // result files, across any order/doctor). Append `/{patientId}/reports-history`.
  doctorPatientReportsHistory:
    "/api/v1/consultation/doctor/appointments/patients",

  // Notifications
  getUserNotifications: "/api/v1/notification/user",
  markNotificationRead: "/api/v1/notification",
  deleteNotification: "/api/v1/notification",
  getUnreadNotificationCount: "/api/v1/notification/unread-count",
  markAllNotificationsRead: "/api/v1/notification/mark-all-read",

  // Pharmacy Notifications
  getPharmacyNotifications: "/api/v1/pharmacy/notifications",
  markPharmacyNotificationRead: (id) =>
    `/api/v1/pharmacy/notifications/${id}/read`,
  deletePharmacyNotification: (id) => `/api/v1/pharmacy/notifications/${id}`,
  getPharmacyUnreadNotificationCount:
    "/api/v1/pharmacy/notifications/unread-count",
  markAllPharmacyNotificationsRead:
    "/api/v1/pharmacy/notifications/mark-all-read",

  // Pharmacy Chat Orders
  pharmacyChatSendMessage: "/api/v1/pharmacy/chat/send",
  pharmacyChatGetConversations: "/api/v1/pharmacy/chat/conversations",
  pharmacyChatGetMessages: "/api/v1/pharmacy/chat/messages",
  pharmacyChatCreateOrder: "/api/v1/pharmacy/chat/create-order",

  // Consultation Chat (Doctor-Patient)
  consultationChatRoom: "/api/v1/consultation/chat/room",
  consultationChatSend: "/api/v1/consultation/chat/send",
  consultationChatMessages: "/api/v1/consultation/chat/messages",
  consultationChatMarkRead: "/api/v1/consultation/chat/mark-read",
  consultationChatUnreadCount: "/api/v1/consultation/chat/unread-count",
  consultationChatRooms: "/api/v1/consultation/chat/rooms",
  consultationChatUpload: "/api/v1/consultation/chat/upload",
  consultationChatDownload: "/api/v1/consultation/chat/download",
  consultationChatUploadVoice: "/api/v1/consultation/chat/upload-voice",
};
